// extracted by mini-css-extract-plugin
module.exports = {"icon":"FacebookButton_icon__WiMco"};